import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {" "}
      <img src="/ynu.png" alt="Screenshot" className="footer-image" />
    </footer>
  );
};

export default Footer;
